// De rode TEST-balk (TestEnvironmentBanner) staat sticky bovenaan met een z-index boven
// niet-modale drawers (1200). Een persistente drawer rechts begon daardoor ónder de balk:
// kop en sluitknop vielen weg. De balk zet zijn eigen hoogte in deze CSS-variabele; op
// productie (geen balk) bestaat hij niet en valt alles terug op 0px — daar verandert niets.
export const TESTBALK_VAR = '--ff-testbalk-hoogte';

/** Hoogte van de vaste kopbalk in AppShell (px). Eén bron: AppShell en Dagstart rekenen ermee. */
export const TOPBAR_HOOGTE = 40;

/** `top` voor sticky/fixed elementen die bovenaan het venster plakken: net onder de TEST-balk. */
export const TESTBALK_TOP = `var(${TESTBALK_VAR}, 0px)`;

/** `top` voor sticky elementen die op `px` onder de vensterrand plakken, verschoven met de TEST-balk. */
export const testbalkPlus = (px) => `calc(var(${TESTBALK_VAR}, 0px) + ${px}px)`;

/** Vensterhoogte minus de TEST-balk — voor kolommen die de volle hoogte vullen (zijbalk). */
export const VENSTER_ONDER_TESTBALK = `calc(100vh - var(${TESTBALK_VAR}, 0px))`;

/** Hoogte van het zichtbare werkvlak onder TEST-balk en kopbalk — voor schermen die zelf scrollen. */
export const WERKVLAK_HOOGTE = `calc(100vh - var(${TESTBALK_VAR}, 0px) - ${TOPBAR_HOOGTE}px)`;

/** sx voor het papier van een drawer rechts: begint onder de TEST-balk, niet erachter. */
export const onderTestbalk = {
  top: TESTBALK_TOP,
  height: `calc(100% - var(${TESTBALK_VAR}, 0px))`,
};

/** Zet (of wist, bij `null`) de hoogte van de balk op de documentroot. */
export function zetTestbalkHoogte(px) {
  const root = typeof document !== 'undefined' ? document.documentElement : null;
  if (!root) return;
  if (px === null || px === undefined) root.style.removeProperty(TESTBALK_VAR);
  else root.style.setProperty(TESTBALK_VAR, `${Math.max(0, Math.round(px))}px`);
}
